export enum FacadePageType {
  Category,
  Trunkshow,
  TrunkshowPieces,
  Editorial,
  Guide,
  Designer
}

export const getRuleContextFromSlug = (pageType: FacadePageType, slug: string) => {
  const ruleSlug = slug.replace(/[-/]/g, '_');
  let ruleContext: string;

  switch (pageType) {
    case FacadePageType.Category: {
      ruleContext = `category_${ruleSlug}`;
      break;
    }
    case FacadePageType.Designer: {
      ruleContext = `designer_${ruleSlug}`;
      break;
    }
    case FacadePageType.Guide: {
      ruleContext = `guide_${ruleSlug}`;
      break;
    }
    case FacadePageType.Trunkshow: {
      ruleContext = `trunkshow_${ruleSlug}`;
      break;
    }
    case FacadePageType.TrunkshowPieces: {
      ruleContext = ['trunkshow_pieces', ruleSlug].filter(Boolean).join('_');
      break;
    }
    default: {
      ruleContext = slug;
    }
  }

  return ruleContext;
};
